import { MainLayoutContainer } from "components/Layout";
import { Add } from "@mui/icons-material";
import { TABLE_ACTIONS, SortOrder } from "helpers/constants";
import { Link, useNavigate } from "react-router-dom";
import { useSurvey } from "./useSurvey";
import CustomTable from "components/Table/CustomTable";
import ConfirmActionModal from "modals/ConfirmActionModal/ConfirmActionModal";
import { ResponsiveButton } from "components/Button";
import { Link as LinkBase, Stack } from "@mui/material";

export const SurveyList = () => {
  const navigate = useNavigate();
  const {
    loading,
    deleteSurveyOpen,
    organizationId,
    surveys,
    handleActionClick,
    setDeleteSurveyOpen,
    handleDelete,
  } = useSurvey();

  return (
    <MainLayoutContainer
      title="Surveys"
      loading={loading}
      error={undefined}
      buttonActions={
        <ResponsiveButton
          onClick={() => {
            navigate(
              organizationId
                ? `/organization/${organizationId}/survey/create`
                : "/survey/create",
            );
          }}
          icon={<Add />}
        >
          Create New Survey
        </ResponsiveButton>
      }
    >
      <CustomTable
        entities={surveys}
        handleActionClick={handleActionClick}
        fieldToFilter={(row: any, filterText: string) =>
          row.name.toLowerCase().includes(filterText.toLowerCase())
        }
        columns={[
          {
            id: "name",
            label: "Name",
            value: "name",
          },
          {
            id: "survey_id",
            value: (row: any) => (
              <Stack direction="row" spacing={2} alignItems={"center"}>
                <LinkBase
                  sx={{ cursor: "pointer" }}
                  component={Link}
                  to={
                    organizationId
                      ? `/organization/${organizationId}/survey/${row.survey_id}`
                      : `/survey/${row.survey_id}`
                  }
                >
                  View
                </LinkBase>
              </Stack>
            ),
          },
          { id: "actions", value: "" },
        ]}
        isSelectable={false}
        allowedMenuItems={[
          TABLE_ACTIONS.VIEW,
          TABLE_ACTIONS.EDIT,
          TABLE_ACTIONS.DELETE,
          TABLE_ACTIONS.VIEW_ANSWERS,
          TABLE_ACTIONS.ANSWER_SURVEY,
        ]}
        extraActionItems={[]}
        idColumn={"survey_id"}
        sortDefault={SortOrder.desc}
        sortDefaultField={"created_at"}
        enableCardViewInSmallDevices={true}
      />
      {deleteSurveyOpen && (
        <ConfirmActionModal
          title={"Heads up!"}
          message={`Are you sure you want to delete this Survey?`}
          show={deleteSurveyOpen}
          onConfirm={handleDelete}
          onDismiss={() => {
            setDeleteSurveyOpen(false);
          }}
        />
      )}
    </MainLayoutContainer>
  );
};
